import React from 'react';
import type { ReactNode } from 'react';

import { ThemeProvider } from './ThemeProvider';
import { PackageProviders } from './PackageProviders';
import type { ThemeProviderProps } from './ThemeProvider';

type ReckonBalanceCoreProps = {
  themeMode: 'light';
  children?: ReactNode;
} & Pick<ThemeProviderProps, 'linkComponent' | 'themeOverrides'>;

export const ReckonBalanceCore = ({
  themeOverrides,
  linkComponent,
  children,
}: ReckonBalanceCoreProps) => {
  return (
    <ThemeProvider
      linkComponent={linkComponent}
      themeOverrides={themeOverrides}
    >
      <PackageProviders>{children}</PackageProviders>
    </ThemeProvider>
  );
};
